import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding, HostListener,
  Input,
  OnInit,
  Output, ViewChild
} from '@angular/core';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';
import { LMListUtilService } from '@list/services/lm-list-util.service';
import { SohoCheckBoxComponent } from 'ids-enterprise-ng';

@Component({
  selector: 'lm-block-item',
  templateUrl: './lm-block-item.component.html',
  styleUrls:   [ 'lm-block-item.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LMBlockItemComponent implements OnInit {
  @Input() isSelectable = true;
  @Input() content: 'image-item' | 'sectioned-card';
  @Input() populateTooltip: boolean;
  @Input() blockGridOptions: BlockGridOptions = null;
  @Input() set data(imageData: BlockGridData) {
    this._data = imageData;

    if (this.populateTooltip) {
      this._populateTooltip();
    }
  };

  @HostBinding('style.width.px') @Input() width: string;
  @HostBinding('style.margin') @Input() margin = '15px 0 0 15px';

  @HostBinding('class') get hostClassName() {
    return this.content;
  }

  @HostListener('mouseover') onMouseOver() {
    this.showCheckBox();
  }

  @HostListener('mouseout') onMouseOut() {
    this.hideCheckBox();
  }

  @Output() itemSelected = new EventEmitter<LMBlockGridItemEvent>();
  @Output() itemUnSelected = new EventEmitter<LMBlockGridItemEvent>();
  @Output() itemDoubleClicked = new EventEmitter<LMBlockGridItemEvent>();
  @Output() contextMenu = new EventEmitter<LMBlockGridItemEvent>();

  // @ViewChild('Checkbox') checkbox: ElementRef;
  @ViewChild('Checkbox') checkbox: SohoCheckBoxComponent;

  public selected;
  public tooltip: string;
  public checkboxIsVisible = false;

  private _data: BlockGridData;

  constructor(
    protected lmFormatUtilService: LMFormatUtilService,
    private lmListUtilService: LMListUtilService
  ) {}

  ngOnInit() {}

  public selectItem() {
    // Set timeout to allow double click time to be captured before single click
    setTimeout(() => {
      const blockGridItemEvent: LMBlockGridItemEvent = {
        cell: -1,
        item: this,
        row: this.data.dvIndex,
        originalEvent: null,
        type: null
      };

      this.check();
      this.itemSelected.emit(blockGridItemEvent);
    });
  }

  public unSelectItem() {
    const blockGridItemEvent: LMBlockGridItemEvent = {
      cell: -1,
      item: this,
      row: this.data.dvIndex,
      originalEvent: null,
      type: null
    };

    this.unCheck();
    this.itemUnSelected.emit(blockGridItemEvent);
  }

  public doubleClick() {
    const blockGridItemEvent: LMBlockGridItemEvent = {
      cell: -1,
      item: this,
      row: this.data.dvIndex,
      originalEvent: null,
      type: null
    };

    this.itemDoubleClicked.emit(blockGridItemEvent);
  }

  public onContextMenu(e?: JQuery.TriggeredEvent) {
    e.preventDefault();

    this.selected = true;

    const blockGridItemEvent: LMBlockGridItemEvent = {
      cell: -1,
      item: this,
      row: this.data.dvIndex,
      originalEvent: e,
      type: null
    };

    this.contextMenu.emit(blockGridItemEvent);
  }

  // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
  public get data(): BlockGridData {
    return this._data;
  }

  public showCheckBox() {
    this.checkboxIsVisible = true;
  }

  public hideCheckBox() {
    this.checkboxIsVisible = false;
  }

  public check() {
    this.selected = true;
  }

  public unCheck() {
    this.selected = undefined;
  }

  private _populateTooltip() {
    if (this._data && this._data.detailFields) {
      this.tooltip = this.lmListUtilService.buildDetailFieldsAsTooltip(this._data.dataView, this._data.detailFields);
    }
  }
}
